import React, { useContext, useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect
} from "react-router-dom";

import { AuthContext } from "./app/Context/auth";
import { usePermissoesAcesso } from "./app/Utils/permissoesAcesso";
import ExportarListaAtual from "./app/Components/ExportarLista/ExportarLista";
import CadastroDP from "./app/CadastroDP/cadastrodp";
import CadastroFuncionario from "./app/CadastroDP/cadastrofuncionario";
import RupturasDoDia from "./app/CadastroAgendaRuptura/RupturasDoDia";
import ListaEnsaiosRAA from "./app/CadastroRAA/ListaEnsaiosRAA";
import LeiturasRAA from "./app/CadastroRAA/LeiturasRAA";
import CadastroExtracoes from "./app/CadastroExtracoes/CadastroExtracoes";
import DetalhesExtracao from "./app/CadastroExtracoes/DetalhesExtracao";
import CadastroEsclerometria from "./app/CadastroEsclerometria/CadastroEsclerometria";
import DetalhesEsclerometria from "./app/CadastroEsclerometria/DetalhesEsclerometria";
import CadastroTracao from "./app/CadastroTracao/CadastroTracao";
import DetalhesTracao from "./app/CadastroTracao/DetalhesTracao";
import CadastroArgamassa from "./app/CadastroArgamassa/CadastroArgamassa";
import DetalhesArgamassa from "./app/CadastroArgamassa/DetalhesArgamassa";
import CadastroModuloElasticidade from "./app/CadastroModuloElasticidade/CadastroModuloElasticidade";
import RelatoriosModuloElasticidade from "./app/CadastroModuloElasticidade/RelatoriosModuloElasticidade";
import CadastroMedicoes from "./app/CadastroMedicoes/CadastroMedicoes";
import ListaMedicoes from "./app/CadastroMedicoes/ListaMedicoes";
import CadastroRupturaPaver from "./app/CadastroRupturaPaver/CadastroRupturaPaver";
import DetalhesRupturaPaver from "./app/CadastroRupturaPaver/DetalhesRupturaPaver";
import CadastroRupturaBlocoCeramico from "./app/CadastroRupturaBlocoCeramico/CadastroRupturaBlocoCeramico";
import DetalhesRupturaBlocoCeramico from "./app/CadastroRupturaBlocoCeramico/DetalhesRupturaBlocoCeramico";
import CadastroRupturaBlocoConcreto from "./app/CadastroRupturaBlocoConcreto/CadastroRupturaBlocoConcreto";
import DetalhesRupturaBlocoConcreto from "./app/CadastroRupturaBlocoConcreto/DetalhesRupturaBlocoConcreto";
import CadastroRupturaTijoloSoloCimento from "./app/CadastroRupturaTijoloSoloCimento/CadastroRupturaTijoloSoloCimento";
import DetalhesRupturaTijoloSoloCimento from "./app/CadastroRupturaTijoloSoloCimento/DetalhesRupturaTijoloSoloCimento";
import CadastroCaracterizacao from "./app/CadastroCaracterizacao/CadastroCaracterizacao";
import DetalhesCaracterizacao from "./app/CadastroCaracterizacao/DetalhesCaracterizacao";
import DetalhesCaracterizacaoMiudo from "./app/CadastroCaracterizacao/DetalhesCaracterizacaoMiudo";
import CadastroCimentoPega from "./app/CadastroCimentoPega/CadastroCimentoPega";
import CadastroCompactacao from "./app/CadastroCompactacao/CadastroCompactacao";
import DetalhesCompactacao from "./app/CadastroCompactacao/DetalhesCompactacao";
import CadastroDensidadeInSitu from "./app/CadastroDensidadeInSitu/CadastroDensidadeInSitu";
import DetalhesDensidadeInSitu from "./app/CadastroDensidadeInSitu/DetalhesDensidadeInSitu";
import CadastroTabelaCapsulas from "./app/CadastroCompactacao/CadastroTabelaCapsulas";
import CadastroTabelaCilindros from "./app/CadastroCompactacao/CadastroTabelaCilindros";
import CadastroTabelaFaixasDnit from "./app/CadastroCompactacao/CadastroTabelaFaixasDnit";
import CadastroDosagem from "./app/CadastroDosagem/CadastroDosagem";
import DetalhesDosagem from "./app/CadastroDosagem/DetalhesDosagem";
import CadastroGestaoMudancas from "./app/CadastroGestaoMudancas/CadastroGestaoMudancas";
import DetalhesGestaoMudancas from "./app/CadastroGestaoMudancas/DetalhesGestaoMudancas";
import CadastroVerificacaoCompetencias from "./app/CadastroVerificacaoCompetencias/CadastroVerificacaoCompetencias";
import DetalhesVerificacaoCompetencias from "./app/CadastroVerificacaoCompetencias/DetalhesVerificacaoCompetencias";
import CadastroListaPresenca from "./app/CadastroListaPresenca/CadastroListaPresenca";
import CadastroAnaliseCriticaDirecao from "./app/CadastroAnaliseCriticaDirecao/CadastroAnaliseCriticaDirecao";
import DetalhesAnaliseCriticaDirecao from "./app/CadastroAnaliseCriticaDirecao/DetalhesAnaliseCriticaDirecao";
import PlanejamentoEstrategico from "./app/CadastroPlanejamentoEstrategico/PlanejamentoEstrategico";
import ManualQualidade from "./app/CadastroManualQualidade/ManualQualidade";
import CadastroGuiaDosagem from "./app/CadastroGuiaDosagem/CadastroGuiaDosagem";
import CadastroSolicitacaoServicos from "./app/CadastroSolicitacaoServicos/CadastroSolicitacaoServicos";
import CadastroPropostaComercial from "./app/CadastroPropostaComercial/CadastroPropostaComercial";
import DetalhesPropostaComercial from "./app/CadastroPropostaComercial/DetalhesPropostaComercial";
import CadastroLocacaoEquipamentos from "./app/CadastroLocacaoEquipamentos/CadastroLocacaoEquipamentos";
import DetalhesLocacaoEquipamentos from "./app/CadastroLocacaoEquipamentos/DetalhesLocacaoEquipamentos";
import CadastroVisitaTecnica from "./app/CadastroVisitaTecnica/CadastroVisitaTecnica";
import DetalhesVisitaTecnica from "./app/CadastroVisitaTecnica/DetalhesVisitaTecnica";
import RelatorioCaracterizacao from "./app/Relatorios/RelatorioCaracterizacao";
import RelatorioDosagem from "./app/Relatorios/RelatorioDosagem";
import CadastroAdesividade from "./app/CadastroAdesividade/CadastroAdesividade";
import DetalhesAdesividade from "./app/CadastroAdesividade/DetalhesAdesividade";
import RelatorioAdesividade from "./app/Relatorios/RelatorioAdesividade";
import CadastroCaracterizacaoAsfalto from "./app/CadastroCaracterizacaoAsfalto/CadastroCaracterizacaoAsfalto";
import DetalhesCaracterizacaoAsfalto from "./app/CadastroCaracterizacaoAsfalto/DetalhesCaracterizacaoAsfalto";
import CadastroFaixasDnitAsfalto from "./app/CadastroCaracterizacaoAsfalto/CadastroFaixasDnitAsfalto";
import CadastroTracoCbuq from "./app/CadastroTracoCbuq/CadastroTracoCbuq";
import RelatorioTracoCbuqPrint from "./app/CadastroTracoCbuq/RelatorioTracoCbuqPrint";



/* =======================
   PÚBLICO
======================= */
import Site from "./site/site";
import SiteSaas from "./siteSaas/SiteSaas";
import Demonstracao from "./siteSaas/Demonstracao";
import AdquirirPlano from "./siteSaas/AdquirirPlano";
import Login from "./app/Login/login";
import ResetSenha from "./app/ResetSenha/resetsenha";

/* =======================
   ADMIN / COLABORADOR
======================= */
import HomeDashboard from "./app/HomeDashboard/homeDashboard";
import AdminKpiRespostas from "./app/KPIs/AdminKpiRespostas";
import AdminPsicossocialRespostas from "./app/Psicossocial/AdminPsicossocialRespostas";
import CadastroPsicossocial from "./app/Psicossocial/CadastroPsicossocial";
import ResponderPsicossocial from "./app/Psicossocial/ResponderPsicossocial";
import ResultadosPsicossocial from "./app/Psicossocial/ResultadosPsicossocial";
import SGQ from "./app/SGQ/sgq";
import AdminSGQ from "./app/SGQ/AdminSGQ";
import ListaMestra from "./app/SGQ/ListaMestra";
import KPIEventoForm from "./app/KPIs/KPIEventoForm";
import ListaOcorrencias from "./app/KPIs/components/ListaOcorrencias";
import OcorrenciaDetalhe from "./app/KPIs/components/OcorrenciaDetalhe";
import CadastroEquipamentos from "./app/CadastroEquipamentos/cadastroequipamentos";
import CadastroEquipamentoDetalhes from "./app/CadastroEquipamentoDetalhes/cadastroequipamentosdetalhes";
import GerarEtiquetas from "./app/Etiquetas/GerarEtiquetas";
import AgendaRuptura from "./app/CadastroAgendaRuptura/AgendaRuptura";
import CadastroClientes from "./app/CadastroClientes/CadastroClientes";
import ListaCalibracoesPrensa from "./app/CalibracaoPrensa/ListaCalibracoesPrensa";
import CalibracaoPrensa from "./app/CalibracaoPrensa/CalibracaoPrensa";
import ListaCalibracoesExternasPrensa from "./app/CalibracaoPrensaExterna/ListaCalibracoesExternasPrensa";
import CalibracaoExternaPrensa from "./app/CalibracaoPrensaExterna/CalibracaoExternaPrensa";
import ListaCalibracoesPrensaSolos from "./app/CalibracaoPrensaSolos/ListaCalibracoesPrensaSolos";
import CalibracaoPrensaSolos from "./app/CalibracaoPrensaSolos/CalibracaoPrensaSolos";


/* =======================
   CLIENTE
======================= */
import Laudos from "./app/Laudos/Laudos";

/* =======================
   CADASTROS
======================= */
import CadastroUsuarios from "./app/CadastroUsuarios/CadastroUsuarios";
import CadastroMateriais from "./app/CadastroMateriais/cadastromateriais";
import CadastroLaudos from "./app/CadastroLaudos/cadastrolaudos";
import CadastroObras from "./app/CadastroObras/CadastroObras";
import CadastroConcreteiras from "./app/CadastroConcreteiras/CadastroConcreteiras";
import CadastroQualificacaoFornecedores from "./app/CadastroQualificacaoFornecedores/CadastroQualificacaoFornecedores";
import CadastroPlanoComunicacao from "./app/CadastroPlanoComunicacao/CadastroPlanoComunicacao";
import CadastroObjetivosQualidade from "./app/CadastroObjetivosQualidade/CadastroObjetivosQualidade";
import DetalhesObjetivosQualidade from "./app/CadastroObjetivosQualidade/DetalhesObjetivosQualidade";
import CadastroMatrizRiscos from "./app/CadastroMatrizRiscos/CadastroMatrizRiscos";
import CadastroRequisitosLegais from "./app/CadastroRequisitosLegais/CadastroRequisitosLegais";
import CadastroPlanejamentoRecursos from "./app/CadastroPlanejamentoRecursos/CadastroPlanejamentoRecursos";
import DetalhesPlanejamentoRecursos from "./app/CadastroPlanejamentoRecursos/DetalhesPlanejamentoRecursos";
import CadastroControleResiduos from "./app/CadastroControleResiduos/CadastroControleResiduos";
import CadastroProgramaTreinamentos from "./app/CadastroProgramaTreinamentos/CadastroProgramaTreinamentos";
import CadastroQuadroCompetencias from "./app/CadastroQuadroCompetencias/CadastroQuadroCompetencias";
import CadastroControleManutencaoEquipamentos from "./app/CadastroControleManutencaoEquipamentos/CadastroControleManutencaoEquipamentos";
import CadastroCaixinhaEmpresa from "./app/CadastroCaixinhaEmpresa/CadastroCaixinhaEmpresa";
import NovoCadastroMateriais from "./app/NovoCadastroMateriais/NovoCadastroMateriais";
import ControleTemperaturaTanqueCura from "./app/ControleTemperaturaTanqueCura/ControleTemperaturaTanqueCura";
import ConfigLogoRelatorios from "./app/ConfigLogoRelatorios/ConfigLogoRelatorios";
import ExportacaoDados from "./app/ExportacaoDados/ExportacaoDados";
import BotaoTutorialPagina from "./app/Components/TutorialCadastro/BotaoTutorialPagina";
import AvisoMensalidade from "./app/Components/AvisoMensalidade/AvisoMensalidade";
import PopupSistema from "./app/Components/PopupSistema/PopupSistema";

/* =======================
   APROVAÇÕES
======================= */
import Aprovacoes from "./app/Aprovacoes/Aprovacoes";

/* =======================
   KPIs
======================= */
import AdminKPIs from "./app/KPIs/AdminKPIs";
import KPIQuestions from "./app/KPIs/KPIQuestions";
import KPIFormGeral from "./app/KPIs/KPIFormGeral";
import KPIListaPorEscopo from "./app/KPIs/KPIListaPorEscopo";

const WHATSAPP_SUPORTE_URL =
  "https://wa.me/5563992281407?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20com%20a%20utiliza%C3%A7%C3%A3o%20do%20sistema%20QualiInfra.";

function RodapeSuporte() {
  return (
    <footer
      style={{
        position: "fixed",
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 1200,
        padding: "10px 16px",
        backgroundColor: "#0d47a1",
        color: "#ffffff",
        textAlign: "center",
        fontSize: "0.9rem",
        boxShadow: "0 -2px 8px rgba(15, 23, 42, 0.18)",
      }}
    >
      Em caso de dúvidas sobre a utilização do sistema, entre em contato pelo WhatsApp:{" "}
      <a
        href={WHATSAPP_SUPORTE_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#ffffff", fontWeight: 700, textDecoration: "underline" }}
      >
        (63) 99228-1407
      </a>
    </footer>
  );
}

/* =====================================================
   APP
===================================================== */
function ProgressoBotoesSalvar() {
  useEffect(() => {
    const botoesAtivos = new Map();

    function aplicarProgresso(botao, valor) {
      const progresso = Math.max(0, Math.min(100, Math.round(valor)));
      botao.classList.add("botao-salvando-progresso");
      botao.style.setProperty("--progresso-salvamento", `${progresso}%`);
      botao.setAttribute("data-progresso-salvamento", `${progresso}%`);
    }

    function limparBotao(botao, estado) {
      if (estado?.intervalo) clearInterval(estado.intervalo);
      if (estado?.finalizacao) clearTimeout(estado.finalizacao);
      botao.classList.remove("botao-salvando-progresso");
      botao.style.removeProperty("--progresso-salvamento");
      botao.removeAttribute("data-progresso-salvamento");
      botoesAtivos.delete(botao);
    }

    function finalizarBotao(botao, estado) {
      if (estado.finalizando) return;
      estado.finalizando = true;
      if (estado.intervalo) clearInterval(estado.intervalo);
      aplicarProgresso(botao, 100);
      estado.finalizacao = setTimeout(() => limparBotao(botao, estado), 350);
    }

    function iniciarBotao(botao, percentualInformado) {
      const estado = {
        valor: percentualInformado ?? 5,
        intervalo: null,
        finalizacao: null,
        finalizando: false,
      };

      aplicarProgresso(botao, estado.valor);

      if (percentualInformado === null) {
        estado.intervalo = setInterval(() => {
          estado.valor = Math.min(92, estado.valor + (estado.valor < 70 ? 4 : 1));
          aplicarProgresso(botao, estado.valor);
        }, 350);
      }

      botoesAtivos.set(botao, estado);
    }

    function sincronizarBotoes() {
      botoesAtivos.forEach((estado, botao) => {
        if (!document.body.contains(botao)) {
          limparBotao(botao, estado);
          return;
        }

        if (!/salvando/i.test(botao.textContent || "")) {
          finalizarBotao(botao, estado);
        }
      });

      document.querySelectorAll("button").forEach((botao) => {
        const texto = botao.textContent || "";
        if (!/salvando/i.test(texto)) return;

        const percentualNoTexto = texto.match(/(\d{1,3})\s*%/);
        const percentualInformado = percentualNoTexto
          ? Math.min(100, Number(percentualNoTexto[1]))
          : null;
        const estado = botoesAtivos.get(botao);

        if (!estado) {
          iniciarBotao(botao, percentualInformado);
        } else if (percentualInformado !== null) {
          estado.valor = percentualInformado;
          aplicarProgresso(botao, percentualInformado);
        }
      });
    }

    const observador = new MutationObserver(sincronizarBotoes);
    observador.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true,
    });
    sincronizarBotoes();

    return () => {
      observador.disconnect();
      botoesAtivos.forEach((estado, botao) => limparBotao(botao, estado));
    };
  }, []);

  return null;
}

function App() {
  const { podeAcessarRota } = usePermissoesAcesso();
  const { carregandoAuth } = useContext(AuthContext);
  const SitePublico = process.env.REACT_APP_ENV === "prod" ? Site : SiteSaas;

  /* =====================================================
     SECURE ROUTE POR TIPO
  ===================================================== */
  const SecureRoutePorTipo = ({ component: Component, tipos, somenteAdminPrincipal = false, ...rest }) => {
    const tipoUsuario =
      (localStorage.getItem("tipoUsuario") || "").toLowerCase();
    const planoUsuario =
      (localStorage.getItem("planoUsuario") || "").toLowerCase();
    const isSuperadmin = localStorage.getItem("superadmin") === "S";
    const isAdminPrincipal = localStorage.getItem("adminPrincipal") === "S";

    const tiposPermitidos = tipos.map(t => t.toLowerCase());

    return (
      <Route
        {...rest}
        render={(props) => {
          if (carregandoAuth) return null;

          if (!tiposPermitidos.includes(tipoUsuario)) {
            return <Redirect to="/app" />;
          }

          if (somenteAdminPrincipal && !isAdminPrincipal && !isSuperadmin && !podeAcessarRota(props.location.pathname)) {
            return <Redirect to="/dashboard" />;
          }

          if (isSuperadmin && props.location.pathname !== "/app/cadastrousuarios") {
            return <Redirect to="/app/cadastrousuarios" />;
          }

          return (
            <>
              <AvisoMensalidade />
              <Component {...props} />
              {planoUsuario === "demonstracao" && <RodapeSuporte />}
              <BotaoTutorialPagina
                sx={{
                  position: "fixed",
                  right: { xs: 12, md: 24 },
                  bottom: planoUsuario === "demonstracao"
                    ? { xs: 70, md: 64 }
                    : { xs: 12, md: 24 },
                  zIndex: 1250,
                  bgcolor: "background.paper",
                  boxShadow: 3,
                  "&:hover": { bgcolor: "background.paper" },
                  "@media print": { display: "none" },
                }}
              />
            </>
          );
        }}
      />
    );
  };


  return (
    <BrowserRouter>
      <ProgressoBotoesSalvar />
      <PopupSistema />
      <ExportarListaAtual />
      <Switch>

        {/* =======================
           ROTAS PÚBLICAS
        ======================= */}
        <Route exact path="/" component={SitePublico} />
        <Route exact path="/demonstracao" component={Demonstracao} />
        <Route exact path="/adquirir-plano" component={AdquirirPlano} />
        <Route exact path="/app" component={Login} />
        <Route exact path="/app/resetsenha" component={ResetSenha} />
        <Route exact path="/psicossocial/responder/:token" component={ResponderPsicossocial} />
        <Route exact path="/psicossocial/resultados/:token" component={ResultadosPsicossocial} />

        {/* =======================
           ADMIN
        ======================= */}
        <SecureRoutePorTipo
          exact
          path="/dashboard"
          component={HomeDashboard}
          tipos={["admin", "colaborador"]}
        />

        <SecureRoutePorTipo
            exact
            path="/sgq"
            component={SGQ}
            tipos={["admin", "colaborador", "qualidade"]}
          />

            <SecureRoutePorTipo
            exact
            path="/app/calibracao-prensa"
            component={ListaCalibracoesPrensa}
            tipos={["admin"]}
          />
            <SecureRoutePorTipo
              exact
              path="/app/calibracao-prensa/:id"
              component={CalibracaoPrensa}
              tipos={["admin"]}
            />
            <SecureRoutePorTipo
              exact
              path="/app/calibracao-prensa-externa"
              component={ListaCalibracoesExternasPrensa}
              tipos={["admin"]}
            />
            <SecureRoutePorTipo
              exact
              path="/app/calibracao-prensa-externa/:id"
              component={CalibracaoExternaPrensa}
              tipos={["admin"]}
            />
            <SecureRoutePorTipo
              exact
              path="/app/calibracao-prensa-solos"
              component={ListaCalibracoesPrensaSolos}
              tipos={["admin"]}
            />
            <SecureRoutePorTipo
              exact
              path="/app/calibracao-prensa-solos/:id"
              component={CalibracaoPrensaSolos}
              tipos={["admin"]}
            />

          
            <SecureRoutePorTipo
            exact
            path="/app/ensaio-raa"
            component={ListaEnsaiosRAA}
            tipos={["cliente", "colaborador", "admin"]}
          />

          <SecureRoutePorTipo
            exact
            path="/app/ensaio-raa/:ensaioId"
            component={LeiturasRAA}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/extracoes-testemunhos"
            component={CadastroExtracoes}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/extracoes-testemunhos/:extracaoId"
            component={DetalhesExtracao}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/esclerometria"
            component={CadastroEsclerometria}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/esclerometria/:esclerometriaId"
            component={DetalhesEsclerometria}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/resistencia-tracao"
            component={CadastroTracao}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/resistencia-tracao/:tracaoId"
            component={DetalhesTracao}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo exact path="/app/ensaio-argamassa" component={CadastroArgamassa} tipos={["admin", "colaborador"]} />
          <SecureRoutePorTipo exact path="/app/ensaio-argamassa/:argamassaId" component={DetalhesArgamassa} tipos={["admin", "colaborador"]} />
          <SecureRoutePorTipo
            exact
            path="/app/modulo-elasticidade"
            component={CadastroModuloElasticidade}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/relatorios/modulo-elasticidade"
            component={RelatoriosModuloElasticidade}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/medicoes"
            component={ListaMedicoes}
            tipos={["admin"]}
            somenteAdminPrincipal
          />
          <SecureRoutePorTipo
            exact
            path="/app/medicoes/novo"
            component={CadastroMedicoes}
            tipos={["admin"]}
            somenteAdminPrincipal
          />
          <SecureRoutePorTipo
            exact
            path="/app/medicoes/:medicaoId"
            component={CadastroMedicoes}
            tipos={["admin"]}
            somenteAdminPrincipal
          />
          <SecureRoutePorTipo
            exact
            path="/app/ruptura-paver"
            component={CadastroRupturaPaver}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/ruptura-paver/:paverId"
            component={DetalhesRupturaPaver}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/ruptura-bloco-ceramico"
            component={CadastroRupturaBlocoCeramico}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/ruptura-bloco-ceramico/:blocoCeramicoId"
            component={DetalhesRupturaBlocoCeramico}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/ruptura-bloco-concreto"
            component={CadastroRupturaBlocoConcreto}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/ruptura-bloco-concreto/:blocoConcretoId"
            component={DetalhesRupturaBlocoConcreto}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/ensaio-solo-cimento"
            component={CadastroRupturaTijoloSoloCimento}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/ensaio-solo-cimento/:soloCimentoId"
            component={DetalhesRupturaTijoloSoloCimento}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/cadastro-caracterizacao"
            component={CadastroCaracterizacao}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/cadastro-caracterizacao/:caracterizacaoId"
            component={DetalhesCaracterizacao}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/cadastro-caracterizacao-miudo/:caracterizacaoId"
            component={DetalhesCaracterizacaoMiudo}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/cimento-consistencia-pega"
            component={CadastroCimentoPega}
            tipos={["cliente", "colaborador", "admin"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/cimento-consistencia-pega/:ensaioId"
            component={CadastroCimentoPega}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/ensaio-compactacao"
            component={CadastroCompactacao}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/ensaio-compactacao/:compactacaoId"
            component={DetalhesCompactacao}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/densidade-in-situ"
            component={CadastroDensidadeInSitu}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/densidade-in-situ/:insituId"
            component={DetalhesDensidadeInSitu}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/solicitacao-servicos"
            component={CadastroSolicitacaoServicos}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/proposta-comercial"
            component={CadastroPropostaComercial}
            tipos={["admin"]}
            somenteAdminPrincipal
          />
          <SecureRoutePorTipo
            exact
            path="/app/proposta-comercial/:propostaId"
            component={DetalhesPropostaComercial}
            tipos={["admin"]}
            somenteAdminPrincipal
          />
          <SecureRoutePorTipo
            exact
            path="/app/locacao-equipamentos"
            component={CadastroLocacaoEquipamentos}
            tipos={["admin"]}
            somenteAdminPrincipal
          />
          <SecureRoutePorTipo
            exact
            path="/app/locacao-equipamentos/:locacaoId"
            component={DetalhesLocacaoEquipamentos}
            tipos={["admin"]}
            somenteAdminPrincipal
          />
          <SecureRoutePorTipo
            exact
            path="/app/cadastro-dosagem"
            component={CadastroDosagem}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/cadastro-dosagem/:dosagemId"
            component={DetalhesDosagem}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/gestao-mudancas"
            component={CadastroGestaoMudancas}
            tipos={["admin", "qualidade"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/gestao-mudancas/:registroId"
            component={DetalhesGestaoMudancas}
            tipos={["admin", "qualidade"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/verificacao-competencias"
            component={CadastroVerificacaoCompetencias}
            tipos={["admin", "qualidade"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/verificacao-competencias/:registroId"
            component={DetalhesVerificacaoCompetencias}
            tipos={["admin", "qualidade"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/listas-presenca-treinamentos"
            component={CadastroListaPresenca}
            tipos={["admin", "qualidade"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/listas-presenca-treinamentos/:registroId"
            component={CadastroListaPresenca}
            tipos={["admin", "qualidade"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/analise-critica-direcao"
            component={CadastroAnaliseCriticaDirecao}
            tipos={["admin", "qualidade"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/analise-critica-direcao/:registroId"
            component={DetalhesAnaliseCriticaDirecao}
            tipos={["admin", "qualidade"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/planejamento-estrategico"
            component={PlanejamentoEstrategico}
            tipos={["admin", "qualidade"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/manual-qualidade"
            component={ManualQualidade}
            tipos={["admin", "qualidade"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/guias-dosagem"
            component={CadastroGuiaDosagem}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/relatorios-visita-tecnica"
            component={CadastroVisitaTecnica}
            tipos={["admin"]}
            somenteAdminPrincipal
          />
          <SecureRoutePorTipo
            exact
            path="/app/relatorios-visita-tecnica/:visitaTecnicaId"
            component={DetalhesVisitaTecnica}
            tipos={["admin"]}
            somenteAdminPrincipal
          />
          <SecureRoutePorTipo
            exact
            path="/app/relatorios/caracterizacao"
            component={RelatorioCaracterizacao}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/relatorios/dosagem"
            component={RelatorioDosagem}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/adesividade-ligante-betuminoso"
            component={CadastroAdesividade}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/caracterizacao-asfalto"
            component={CadastroCaracterizacaoAsfalto}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/caracterizacao-asfalto/:caracterizacaoAsfaltoId"
            component={DetalhesCaracterizacaoAsfalto}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/traco-cbuq"
            component={CadastroTracoCbuq}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/traco-cbuq/:tracoId"
            component={CadastroTracoCbuq}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/traco-cbuq/:tracoId/relatorio"
            component={RelatorioTracoCbuqPrint}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/adesividade-ligante-betuminoso/:adesividadeId"
            component={DetalhesAdesividade}
            tipos={["admin", "colaborador"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/relatorios/adesividade-ligante-betuminoso"
            component={RelatorioAdesividade}
            tipos={["admin", "colaborador"]}
          />
        <SecureRoutePorTipo
             exact
            path="/app/agendamoldagem"
            component={AgendaRuptura }
            tipos={["admin", "colaborador", "qualidade", "cliente"]}
          />
        <SecureRoutePorTipo
             exact
            path="/app/agendamoldagem/:moldagemId"
            component={AgendaRuptura }
            tipos={["admin", "colaborador", "qualidade", "cliente"]}
          />
          <SecureRoutePorTipo
            exact
            path="/app/rupturas-hoje"
            component={RupturasDoDia}
            tipos={["admin", "colaborador", "qualidade"]}
          />

        <SecureRoutePorTipo
          exact
          path="/Lista-Mestra"
          component={ListaMestra}
          tipos={["admin"]}
        />

        {/* =======================
           KPIs (ADMIN)
        ======================= */}
        <SecureRoutePorTipo
          exact
          path="/admin/kpis"
          component={AdminKPIs}
          tipos={["admin"]}
        />

        <SecureRoutePorTipo
          exact
          path="/admin/kpis/:id/perguntas"
          component={KPIQuestions}
          tipos={["admin"]}
        />

        <SecureRoutePorTipo
          exact
          path="/admin/kpis/respostas"
          component={AdminKpiRespostas}
          tipos={["admin"]}
        />

        <SecureRoutePorTipo
  exact
  path="/admin/psicossocial/respostas"
  component={AdminPsicossocialRespostas}
  tipos={["admin"]}
/>

        <SecureRoutePorTipo
          exact
          path="/admin/psicossocial/cadastro"
          component={CadastroPsicossocial}
          tipos={["admin"]}
        />

        <SecureRoutePorTipo
            exact
            path="/app/cadastro-equipamentos"
            component={CadastroEquipamentos}
            tipos={["admin", "qualidade"]}
          />

          <SecureRoutePorTipo
            exact
            path="/app/cadastro-equipamento/:equipamentoId"
            component={CadastroEquipamentoDetalhes}
            tipos={["admin", "qualidade"]}
          />


        {/* =======================
           KPI EVENTO (ADMIN + COLABORADOR)
        ======================= */}
        <SecureRoutePorTipo
            exact
            path="/kpi/evento/:kpiId"
            component={KPIEventoForm}
            tipos={["admin", "colaborador"]}
          />


        {/* =======================
          OCORRÊNCIAS / NC / MELHORIAS
        ======================= */}
        <SecureRoutePorTipo
          exact
          path="/app/ocorrencias"
          component={ListaOcorrencias}
          tipos={["admin"]}
        />

        <SecureRoutePorTipo
          path="/ocorrencias/:eventoId"
          component={OcorrenciaDetalhe}
          tipos={["admin"]}
        />


        {/* =======================
           PESQUISA
        ======================= */}
        <SecureRoutePorTipo
          exact
          path="/app/pesquisa"
          component={KPIListaPorEscopo}
          tipos={["cliente", "colaborador", "admin"]}

        />

        <SecureRoutePorTipo
          exact
          path="/app/pesquisa/:kpiId"
          component={KPIFormGeral}
          tipos={["cliente", "colaborador", "admin"]}

        />

        {/* =======================
           CADASTROS (ADMIN)
        ======================= */}
        <SecureRoutePorTipo
          exact
          path="/app/cadastrousuarios"
          component={CadastroUsuarios}
          tipos={["admin"]}
        />

        <SecureRoutePorTipo
          exact
          path="/app/cadastrarlaudos"
          component={CadastroLaudos}
          tipos={["admin"]}
        />

        <SecureRoutePorTipo
          exact
          path="/app/controle-temperatura-tanque-cura"
          component={ControleTemperaturaTanqueCura}
          tipos={["admin", "qualidade", "colaborador"]}
        />

        <SecureRoutePorTipo
          exact
          path="/app/configuracoes/exportacao-dados"
          component={ExportacaoDados}
          tipos={["admin"]}
          somenteAdminPrincipal
        />

        <SecureRoutePorTipo
          exact
          path="/app/configuracoes/tabela-cilindros"
          component={CadastroTabelaCilindros}
          tipos={["admin"]}
          somenteAdminPrincipal
        />

        <SecureRoutePorTipo
          exact
          path="/app/configuracoes/logo-relatorios"
          component={ConfigLogoRelatorios}
          tipos={["admin"]}
          somenteAdminPrincipal
        />

        <SecureRoutePorTipo
          exact
          path="/app/configuracoes/tabela-capsulas"
          component={CadastroTabelaCapsulas}
          tipos={["admin"]}
          somenteAdminPrincipal
        />

        <SecureRoutePorTipo
          exact
          path="/app/configuracoes/faixas-dnit"
          component={CadastroTabelaFaixasDnit}
          tipos={["admin"]}
          somenteAdminPrincipal
        />

        <SecureRoutePorTipo
          exact
          path="/app/configuracoes/faixas-dnit-asfalto"
          component={CadastroFaixasDnitAsfalto}
          tipos={["admin"]}
          somenteAdminPrincipal
        />

        <SecureRoutePorTipo
          exact
          path="/app/NovoCadastroMateriais"
          component={NovoCadastroMateriais}
          tipos={["admin"]}
        />
          <SecureRoutePorTipo
              exact
              path="/app/clientes"
              component={CadastroClientes}
              tipos={["admin", "colaborador"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/cadastroobras"
              component={CadastroObras}
              tipos={["admin", "colaborador"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/cadastro-concreteiras"
              component={CadastroConcreteiras}
              tipos={["admin", "colaborador"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/qualificacao-fornecedores"
              component={CadastroQualificacaoFornecedores}
              tipos={["admin", "colaborador"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/plano-comunicacao"
              component={CadastroPlanoComunicacao}
              tipos={["admin", "qualidade"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/objetivos-qualidade/:cadastroId"
              component={DetalhesObjetivosQualidade}
              tipos={["admin", "qualidade"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/objetivos-qualidade"
              component={CadastroObjetivosQualidade}
              tipos={["admin", "qualidade"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/matriz-riscos"
              component={CadastroMatrizRiscos}
              tipos={["admin", "qualidade"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/requisitos-legais"
              component={CadastroRequisitosLegais}
              tipos={["admin", "qualidade"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/planejamento-recursos"
              component={CadastroPlanejamentoRecursos}
              tipos={["admin", "qualidade"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/planejamento-recursos/:registroId"
              component={DetalhesPlanejamentoRecursos}
              tipos={["admin", "qualidade"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/controle-residuos"
              component={CadastroControleResiduos}
              tipos={["admin", "qualidade"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/programa-treinamentos"
              component={CadastroProgramaTreinamentos}
              tipos={["admin", "qualidade"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/quadro-competencias"
              component={CadastroQuadroCompetencias}
              tipos={["admin", "qualidade"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/controle-manutencao-equipamentos"
              component={CadastroControleManutencaoEquipamentos}
              tipos={["admin", "qualidade"]}
            />

            <SecureRoutePorTipo
              exact
              path="/app/caixinha-empresa"
              component={CadastroCaixinhaEmpresa}
              tipos={["admin", "colaborador"]}
            />

        <SecureRoutePorTipo
          exact
          path="/app/aprovacoes"
          component={Aprovacoes}
          tipos={["admin"]}
        />

        <SecureRoutePorTipo
            exact
            path="/app/departamento-pessoal"
            component={CadastroDP}
            tipos={["admin", "departamento_pessoal"]}
          />

          <SecureRoutePorTipo
            exact
            path="/cadastro-funcionario/:funcionarioId"
            component={CadastroFuncionario}
            tipos={["admin", "departamento_pessoal"]}
          />

          <SecureRoutePorTipo
              exact
              path="/app/departamento-pessoal/novo"
              component={CadastroFuncionario}
              tipos={["admin", "departamento_pessoal"]}
            />


        {/* =======================
           ADMIN + COLABORADOR
        ======================= */}
        <SecureRoutePorTipo
          exact
          path="/admin-sgq"
          component={AdminSGQ}
          tipos={["admin", "qualidade"]}
        />

        <SecureRoutePorTipo
          exact
          path="/app/cadastromateriais"
          component={CadastroMateriais}
          tipos={["admin", "colaborador"]}
        />

          <SecureRoutePorTipo
              exact
              path="/app/GerarEtiquetas"
              component={GerarEtiquetas}
              tipos={["admin", "colaborador"]}
            />
        {/* =======================
           CLIENTE
        ======================= */}
        <SecureRoutePorTipo
          exact
          path="/app/laudos"
          component={Laudos}
          tipos={["cliente"]}
        />

        {/* =======================
           FALLBACK GLOBAL
        ======================= */}
        <Redirect to="/" />

      </Switch>
    </BrowserRouter>
  );
}

export default App;
